import React, { useEffect, useState } from "react";
import cn from "classnames";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Button from "../Buttons/button";
import Tab from "./components/tabs";
import Logo from "../../assets/images/Rectangle 1.svg";
import BasicModal from "../models/models";
import useProfile from "../../services/userData";
import { getUserDetails, selectUser } from "../../redux/slices/userSlice";
import {
  getComopanyNotifications,
  getCompanyHistoryRequest,
  selectCompanyDashboard,
} from "../../redux/slices/companyDashboardSlice";
import {
  getHistoryRequest,
  getNotifications,
  selectPersonalDashboard,
} from "../../redux/slices/personalDashboardSlice";
import { useNotifications } from "../../context/NotificationsContext";
// import { formatedAmount } from "../../utils/helpers";
import { useFormattedAmount } from "../../hooks/useFormattedAmount";

const getCost = (data, date) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const year = date.getFullYear().toString();
  const month = monthNames[date.getMonth()];

  return data[year]?.[month]?.cost || "0.0";
};
function Sidebar({ show, setShow }) {
  const dispatch = useDispatch();
  const notifications = useNotifications();
  const PersonalState = useSelector(selectPersonalDashboard);
  const CompanyState = useSelector(selectCompanyDashboard);
  const State = useSelector(selectUser);
  const profile = useProfile();

  const { pathname } = useLocation();
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [id, setId] = useState(0);
  const [open, setOpen] = useState(false);
  const [cost, setCost] = useState(null);

  const { userDetails } = State;
  const { historyData, notificationsData } = PersonalState || {};
  const { CompanyhistoryData, company_logo, companyNotificationsData } = CompanyState || {};
  const isCompany = pathname.includes("company_dashboard");

  // Select notification source based on dashboard
  const dashboardNotifications =
    isCompany
      ? companyNotificationsData?.notifications || []
      : notificationsData?.notifications || [];

  // Combine dashboard notifications + live socket notifications
  const [allNotifications, setAllNotifications] = useState(dashboardNotifications);

  // Update notifications when Redux changes
  useEffect(() => {
    setAllNotifications(dashboardNotifications);
  }, [dashboardNotifications]);

  // Append real-time notifications from WebSocket
  useEffect(() => {
    if (notifications && notifications.length !== 0) {
      setAllNotifications((prev) => [notifications, ...prev]);
    }
  }, [notifications]);

  // Final unread count
  const unreadCount = allNotifications?.filter((n) => !n.is_read).length;

  const hasServicePermissions =
    userDetails.user?.service_owner ||
    userDetails.user?.service_manager ||
    userDetails.user?.service_reader;
  const isGeneralNCompany =
    userDetails?.user?.general && isCompany;
  const company_image = userDetails?.user?.company_image_url;
  const personal_image = userDetails?.user?.image_url;
  const formatFunction = useFormattedAmount();
  const billingPeriodMonth = historyData?.custom_billing_period?.month || userDetails.user?.active_billing_period 
  const custom_billing_period_id = historyData?.custom_billing_period?.id

  useEffect(() => {
    dispatch(getNotifications());
    dispatch(getComopanyNotifications());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch, company_logo]);

  useEffect(() => {
    if (pathname.includes("personal_dashboard")) {
      if (custom_billing_period_id) {
        dispatch(getHistoryRequest(custom_billing_period_id));
      } else {
        dispatch(getHistoryRequest(null));
      }
    } else if (pathname.includes("company_dashboard")) {
      dispatch(getCompanyHistoryRequest());
    }
  }, [dispatch, pathname]);


  useEffect(() => {
    if (historyData && CompanyhistoryData) {
      const dataToUse = pathname.includes("personal_dashboard")
        ? historyData?.total_monthly_cost
        : CompanyhistoryData?.total_monthly_cost;
      setCost(dataToUse);
    }
  }, [pathname, historyData, CompanyhistoryData]);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const service_id = params.get("service_id");
  const settingModal = params.get("settingModal") === "true";

  useEffect(() => {
    if (service_id || settingModal) {
      setPopup(true);
      setState(22);
      if (service_id) setId(service_id);
    }
  }, [service_id, settingModal]);

  return (
    <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
      <div
        className={cn(
          `sm:pl-[24px] flex flex-col fixed z-[10] bg-[#242B3E] max-h-[100vh] overflow-y-scroll xl:w-[100%] xl:max-w-[356px] xl:overflow-y-visible scrollbar-hide ${
            window.innerWidth < 1280
              ? !show
                ? "left-[0px]"
                : "left-[-350px]"
              : show
              ? "left-[0px]"
              : "left-[-350px]"
          }  transform transition-all duration-500 xl:bg-[transparent] xl:block xl:fixed 2xl:bg-[transparent] 2xl:block 2xl:fixed customize_sidebar`,
          {
            "sm:!h-min": userDetails?.user?.role === "general",
          }
        )}
      >
        <div
          onMouseLeave={() => {
            setOpen(false);
          }}
          className={`px-1 sm:px-[12px] py-[16px] bg-[#242B3E] w-[100%] rounded-b-[32px] animation`}
        >
          <div
            onClick={() => {
              profile.is_evaluator && setOpen(!open);
            }}
            className="flex flex-between transition-all duration-500 gap-[16px] px-[12px] py-[8px] items-center justify-between"
          >
            {pathname.includes("personal_dashboard") ? (
              <div className="flex items-center w-[220px] gap-[16px] cursor-pointer">
                <div>
                  {company_image && (
                    <img
                      src={company_image}
                      alt="logo"
                      className="companyImage"
                    />
                  )}
                  {!company_image && (
                    <div className="w-10">
                      <Skeleton count={2} />
                    </div>
                  )}
                </div>
                <div className="flex flex-col ">
                  {userDetails.user?.name && (
                    <span className="text-primary">
                      {userDetails.user?.name}
                    </span>
                  )}
                  {!userDetails.user?.name && (
                    <span className="text-primary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                  {userDetails.user?.name && (
                    <span className="text-secondary">Personal Dashboard</span>
                  )}
                  {!userDetails.user?.name && (
                    <span className="text-secondary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                </div>
              </div>
            ) : pathname.includes("company_dashboard") &&
              userDetails?.user?.admin ? (
              <div className="flex items-center w-[220px] gap-[16px] cursor-pointer">
                <div>
                  {company_image && (
                    <img
                      src={company_image}
                      alt="logo"
                      className="companyImage"
                    />
                  )}
                  {!company_image && (
                    <div className="w-10">
                      <Skeleton count={2} />
                    </div>
                  )}
                </div>
                <div className="flex flex-col ">
                  {profile?.company_name && (
                    <span className="text-primary">
                      {profile?.company_name}
                    </span>
                  )}
                  {!profile?.company_name && (
                    <span className="text-primary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                  {profile?.company_name && (
                    <span className="text-secondary">Company Dashboard</span>
                  )}
                  {!profile?.company_name && (
                    <span className="text-secondary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex w-[220px] gap-[16px] cursor-pointer">
                <div>
                  {company_image && (
                    <img
                      src={company_image}
                      alt="logo"
                      className="companyImage"
                    />
                  )}
                  {!company_image && (
                    <div className="w-10">
                      <Skeleton count={2} />
                    </div>
                  )}
                </div>
                <div className="flex flex-col ">
                  {profile.company_name && (
                    <span className="text-primary">{profile.company_name}</span>
                  )}
                  {!profile.company_name && (
                    <span className="text-primary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                  {profile.company_name && (
                    <span className="text-secondary">
                      {userDetails.user?.general && hasServicePermissions
                        ? "Services Dashboard"
                        : "Company Dashboard"}
                    </span>
                  )}
                  {!profile.company_name && (
                    <span className="text-secondary w-[130px]">
                      <Skeleton />
                    </span>
                  )}
                </div>
              </div>
            )}

            {profile.is_evaluator && (
              <div className="flex justify-center items-center w-[24px] h-[24px]">
                {!open ? (
                  <div className="flex justify-center items-center w-[24px] h-[24px]">
                    <svg
                      width="15"
                      height="9"
                      viewBox="0 0 15 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.8569 1.42773L8.56404 6.72063C8.17352 7.11115 7.54035 7.11115 7.14983 6.72063L1.85693 1.42773"
                        stroke="#AAADB1"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="flex justify-center items-center w-[24px] h-[24px]">
                    <svg
                      width="15"
                      height="9"
                      viewBox="0 0 15 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.85693 7.42773L7.14983 2.13484C7.54035 1.74432 8.17352 1.74432 8.56404 2.13484L13.8569 7.42774"
                        stroke="#AAADB1"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                )}
              </div>
            )}
          </div>

          <div
            className={`flex flex-col gap-[7px] mt-3 transition-all duration-500 ${
              !open && "hidden"
            }`}
          >
            <div className="text-secondary px-[12px] !text-[11px] !font-semibold !leading-[24px]">
              DASHBOARDS
            </div>
            <div className="flex flex-col px-[4px] ">
              <Link
                to={"/personal_dashboard"}
                onClick={() => {
                  setOpen(!open);
                }}
                className="flex flex-col p-[8px] cursor-pointer transition-all duration-150 ease-linear rounded-[16px] hover:bg-[#363D50] border border-solid border-transparent active:!border-[#FFD74A]"
              >
                <span className="text-primary !font-medium !text-[14px] !leading-[21px]">
                  {userDetails.user?.name}
                </span>
                <span className="text-secondary !leading-[20px]">
                  Personal Dashboard
                </span>
              </Link>
              {/* {
                profile.is_tasker ?
                  <Link to={"/tasker/home"} onClick={() => { setOpen(!open) }} className="flex flex-col p-[8px] cursor-pointer card-animate rounded-[16px]">
                    <span className="text-primary !font-medium !text-[14px] !leading-[21px]">
                      Service Name
                    </span>
                    <span className="text-secondary !leading-[20px]">
                      Service Dashboard
                    </span>
                  </Link> : */}
              <Link
                to={
                  userDetails.user?.general &&
                  userDetails.user?.multi_service_user
                    ? "/company_dashboard/services"
                    : userDetails.user?.general &&
                      userDetails.user?.single_service_user
                    ? `/company_dashboard/services/usage_report/${userDetails.user?.single_service_id}`
                    : "/company_dashboard"
                }
                onClick={() => {
                  setOpen(!open);
                }}
                className="flex flex-col p-[8px] cursor-pointer transition-all duration-150 ease-linear rounded-[16px] hover:bg-[#363D50] border border-solid border-transparent active:!border-[#FFD74A]"
              >
                {" "}
                <span className="text-primary !font-medium !text-[14px] !leading-[21px]">
                  {profile?.company_name}
                </span>
                <span className="text-secondary">
                  {userDetails.user?.general && hasServicePermissions
                    ? "Services Dashboard"
                    : "Company Dashboard"}
                </span>
              </Link>
              {/* } */}
            </div>
          </div>
          {/* this is the dropdown to switch between company and personal profiles. */}
        </div>

        {!pathname.includes("tasker") && (
          <div
            className="p-[24px] rounded-[32px] bg-[#242B3E] max-h-[103px] my-[24px] flex justify-between items-center hidden sm:flex"
            style={{ height: "103px" }}
          >
            <div className="flex flex-col gap-[6px]">
              {cost !== undefined && (
                <span className="text-primary !text-[20px]">
                  {formatFunction(cost ? cost : 0)}
                </span>
              )}
              {cost === undefined && (
                <span className="text-primary !text-[20px] w-[130px]">
                  <Skeleton />
                </span>
              )}
              {cost !== undefined && (
                <span className="text-secondary">
                  {pathname.includes("personal_dashboard")
                    ? `Your monthly cost - ${billingPeriodMonth}`
                    : "Total monthly cost"}
                </span>
              )}
              {cost === undefined && (
                <span className="text-secondary w-[130px]">
                  <Skeleton />
                </span>
              )}
            </div>
            <div className="flex justify-center items-center">
              <Button
                onClick={() => {
                  setPopup(true);
                  setState(11);
                }}
                fill={false}
                secondary={true}
                hoverColor={true}
              >
                History
              </Button>
            </div>
          </div>
        )}

        <div
          className={cn(
            "overflow-y-scroll scrollbar-hide bg-[#242B3E] sm:rounded-t-[32px] main_sidebar",
            {
              "sm:rounded-[32px]": userDetails?.user?.role === "general",
            }
          )}
        >
          <div
            className={`sm:pl-[12px] pt-0 pb-[16px] animation h-[auto] main_sidebar_inner`}
          >
            <div className="flex flex-col sidebar_nav_con">
              <div className="flex flex-col gap-[8px] pt-0"></div>
              {pathname.includes("personal_dashboard") ? (
                <div
                  className={cn(
                    `animation scrollbar-hide flex flex-col gap-[8px] sm:pt-[28px] custom_main_height`,
                    {
                      "!h-fit": userDetails?.user?.role === "general",
                    }
                  )}
                >
                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/notifications"}
                  >
                    <Tab
                      active={
                        pathname.includes("notification")
                      }
                    >
                      <div className="icon-wrapp relative">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="forced-outline"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18 16V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2z"
                            stroke="currentColor"
                            stroke-width="1"
                          />
                        </svg>

                        {unreadCount > 0 && (
                          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
                            {unreadCount}
                          </span>
                        )}

                      </div>
                      <span className="font-bold text-[14px]">Notifications</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/services"}
                  >
                    <Tab
                      active={
                        pathname.includes("services") &&
                        !pathname.includes("team_services")
                      }
                    >
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8061 4.58786C13.322 5.11599 12.9338 5.78973 12.6754 6.5H16.059C16.4478 6.49066 16.7546 6.38859 16.9835 6.22148C17.2208 6.04835 17.4119 5.77833 17.5158 5.37517C17.7544 4.44988 17.1528 3.5 16 3.5C15.1786 3.5 14.4284 3.90893 13.8061 4.58786ZM11.3736 6.5C11.0986 5.78592 10.7108 5.11248 10.2338 4.58567C9.61904 3.90665 8.88615 3.5 8.06714 3.5C6.91439 3.5 6.31274 4.44988 6.55131 5.37517C6.65525 5.77833 6.84638 6.04835 7.08359 6.22148C7.31255 6.38859 7.61937 6.49066 8.00818 6.5H11.3736ZM12.02 5.48309C12.296 4.90975 12.6487 4.37054 13.0689 3.91214C13.8216 3.09107 14.8214 2.5 16 2.5C17.8472 2.5 18.8755 4.10681 18.4842 5.62483C18.3991 5.95474 18.2667 6.24905 18.0895 6.50157C19.4288 6.54872 20.5 7.64926 20.5 9V11C20.5 12.0252 19.883 12.9062 19 13.292V17C19 18.3807 17.8807 19.5 16.5 19.5H7.5C6.11929 19.5 5 18.3807 5 17V13.292C4.11705 12.9062 3.5 12.0252 3.5 11V9C3.5 7.62711 4.60664 6.51269 5.97656 6.50011C5.79993 6.24791 5.66787 5.9541 5.58297 5.62483C5.19159 4.10681 6.21989 2.5 8.06714 2.5C9.24812 2.5 10.2317 3.09335 10.9751 3.91451C11.3904 4.37323 11.7401 4.91194 12.02 5.48309ZM7.99749 7.5H6C5.17157 7.5 4.5 8.17157 4.5 9V11C4.5 11.8284 5.17157 12.5 6 12.5H11.5V7.5H8.06714V7.5007C8.04386 7.5007 8.02064 7.50047 7.99749 7.5ZM16 7.5007V7.5H12.5V12.5H18C18.8284 12.5 19.5 11.8284 19.5 11V9C19.5 8.17157 18.8284 7.5 18 7.5H16.0696C16.0465 7.50047 16.0233 7.5007 16 7.5007ZM12.5 13.5H18V17C18 17.8284 17.3284 18.5 16.5 18.5H12.5V13.5ZM11.5 13.5V18.5H7.5C6.67157 18.5 6 17.8284 6 17V13.5H11.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>

                      <span className="font-bold text-[14px]">Services</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/expenses"}
                  >
                    <Tab active={pathname.includes("expenses")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.6665 8.00163C4.6665 6.1611 6.15846 4.66699 7.99984 4.66699H23.9998C25.8412 4.66699 27.3332 6.1611 27.3332 8.00163V26.7531C27.3332 27.8154 26.1486 28.4563 25.2602 27.864L23.1079 26.4292C22.8664 26.2681 22.5484 26.2819 22.3217 26.4633L20.5826 27.8546C19.8521 28.4389 18.8142 28.4389 18.0838 27.8546L16.4163 26.5206C16.1728 26.3258 15.8269 26.3258 15.5834 26.5206L13.9159 27.8546C13.1855 28.4389 12.1476 28.4389 11.4171 27.8546L9.67802 26.4633C9.45132 26.2819 9.13332 26.2681 8.89176 26.4292L6.73944 27.864C5.85112 28.4563 4.6665 27.8154 4.6665 26.7531V8.00163ZM7.99984 6.00033C6.89569 6.00033 5.99984 6.89664 5.99984 8.00163V26.7531L8.15216 25.3198C8.87684 24.8366 9.83085 24.878 10.5109 25.4221L12.25 26.8134C12.4935 27.0082 12.8395 27.0082 13.083 26.8134L14.7504 25.4794C15.4809 24.8951 16.5188 24.8951 17.2492 25.4794L18.9167 26.8134C19.1602 27.0082 19.5062 27.0082 19.7496 26.8134L21.4887 25.4221C22.1688 24.878 23.1228 24.8366 23.8475 25.3198L25.9992 26.7542L25.9998 8.00163C25.9998 6.89664 25.104 6.00033 23.9998 6.00033H7.99984ZM9.99984 12.0003C9.99984 11.6321 10.2983 11.3337 10.6665 11.3337H16.6665C17.0347 11.3337 17.3332 11.6321 17.3332 12.0003C17.3332 12.3685 17.0347 12.667 16.6665 12.667H10.6665C10.2983 12.667 9.99984 12.3685 9.99984 12.0003ZM19.9998 12.0003C19.9998 11.6321 20.2983 11.3337 20.6665 11.3337H21.3332C21.7014 11.3337 21.9998 11.6321 21.9998 12.0003C21.9998 12.3685 21.7014 12.667 21.3332 12.667H20.6665C20.2983 12.667 19.9998 12.3685 19.9998 12.0003ZM9.99984 17.3337C9.99984 16.9655 10.2983 16.667 10.6665 16.667H21.3332C21.7014 16.667 21.9998 16.9655 21.9998 17.3337C21.9998 17.7018 21.7014 18.0003 21.3332 18.0003H10.6665C10.2983 18.0003 9.99984 17.7018 9.99984 17.3337Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Expenses</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/submissions"}
                  >
                    <Tab active={pathname.includes("submissions")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.7044 3.53243C15.1741 3.22938 15.6872 3.05878 16.2351 3.05878C16.5881 3.05878 16.8814 3.1411 17.116 3.27096C17.3718 3.41256 17.6939 3.31999 17.8355 3.0642C17.9771 2.8084 17.8846 2.48625 17.6288 2.34465C17.2283 2.12296 16.757 2 16.2351 2C15.4566 2 14.747 2.24493 14.1304 2.64277C13.8847 2.80128 13.814 3.12894 13.9726 3.37462C14.1311 3.62029 14.4587 3.69094 14.7044 3.53243ZM18.842 3.85607C18.7584 3.57593 18.4634 3.41667 18.1833 3.50035C17.9031 3.58403 17.7439 3.87897 17.8275 4.15911C17.9097 4.43407 17.9187 4.73924 17.8401 5.04417C17.7763 5.29143 17.6818 5.48968 17.5678 5.64678C17.438 5.82576 17.4365 6.05871 17.5458 6.23589H17.4372C17.2981 6.11172 17.0975 6.06495 16.9091 6.13102C16.717 6.19838 16.4922 6.23586 16.2351 6.23586C15.9428 6.23586 15.7058 6.47287 15.7058 6.76524C15.7058 7.05762 15.9428 7.29463 16.2351 7.29463C16.2863 7.29463 16.3371 7.29357 16.3876 7.29143C16.407 7.29357 16.4266 7.29466 16.4465 7.29466H18.3523C18.849 7.29466 19.1544 7.39412 19.348 7.519C19.5938 7.67745 19.9214 7.60671 20.0798 7.361C20.2383 7.11528 20.1675 6.78764 19.9218 6.62919C19.529 6.3759 19.0378 6.24904 18.4474 6.23686C18.6365 5.96745 18.7758 5.65564 18.8653 5.3085C18.9917 4.81824 18.9797 4.31688 18.842 3.85607ZM13.1729 5.23934C13.3168 4.98484 13.2272 4.66186 12.9727 4.51793C12.7182 4.374 12.3952 4.46363 12.2513 4.71813C12.1564 4.88583 12.0679 5.05766 11.986 5.23249C11.9047 5.06243 11.8177 4.89508 11.7251 4.73151C11.5811 4.47708 11.2581 4.3876 11.0036 4.53164C10.7492 4.67568 10.6597 4.9987 10.8038 5.25313C10.981 5.56611 11.1357 5.89723 11.2661 6.23589H10.0938C9.80144 6.23589 9.56442 6.4729 9.56442 6.76528C9.56442 7.05765 9.80144 7.29466 10.0938 7.29466H11.9893C11.9963 7.2948 12.0033 7.29481 12.0103 7.29466H13.9054C14.1978 7.29466 14.4348 7.05765 14.4348 6.76528C14.4348 6.4729 14.1978 6.23589 13.9054 6.23589H12.7149C12.8396 5.89296 12.9932 5.55697 13.1729 5.23934ZM6.43227 5.64678C6.56211 5.82576 6.56362 6.05871 6.45429 6.23589H6.56291C6.70201 6.11172 6.90263 6.06495 7.09103 6.13102C7.28314 6.19838 7.5079 6.23586 7.76497 6.23586C8.05734 6.23586 8.29436 6.47287 8.29436 6.76524C8.29436 7.05762 8.05734 7.29463 7.76497 7.29463C7.71363 7.29463 7.66257 7.29356 7.61183 7.2914C7.59243 7.29356 7.57272 7.29466 7.55275 7.29466H5.64694C5.1502 7.29466 4.84486 7.39412 4.65119 7.519C4.40547 7.67745 4.07783 7.60671 3.91938 7.361C3.76093 7.11528 3.83168 6.78764 4.07739 6.62919C4.47038 6.37577 4.96196 6.24891 5.55267 6.23684C5.36359 5.96743 5.22429 5.65563 5.13479 5.3085C5.00839 4.81824 5.02043 4.31688 5.15808 3.85607C5.24177 3.57593 5.5367 3.41667 5.81685 3.50035C6.09699 3.58403 6.25625 3.87897 6.17257 4.15911C6.09044 4.43407 6.08142 4.73924 6.16004 5.04417C6.22379 5.29143 6.31831 5.48968 6.43227 5.64678ZM20.9447 8.54303C20.9097 8.25277 20.6459 8.04588 20.3557 8.08094C20.0654 8.11599 19.8585 8.37972 19.8936 8.66998C19.9397 9.05218 19.9404 9.47666 19.9404 9.94161C19.9404 10.3583 19.9402 10.7459 19.9141 11.1008C19.8926 11.3924 20.1116 11.6461 20.4032 11.6676C20.6948 11.689 20.9486 11.47 20.97 11.1784C20.9992 10.7811 20.9992 10.3571 20.9992 9.9524V9.9247C20.9992 9.47888 20.9992 8.9945 20.9447 8.54303ZM4.10565 8.66998C4.1407 8.37972 3.93382 8.11599 3.64355 8.08094C3.35329 8.04588 3.08956 8.25277 3.05451 8.54303C2.99998 8.9945 2.99999 9.47887 3 9.92468V9.92469V9.95238V9.95255C3 10.3572 3 10.7812 3.02922 11.1784C3.05066 11.47 3.30442 11.689 3.59601 11.6676C3.8876 11.6461 4.10659 11.3924 4.08514 11.1008C4.05904 10.7459 4.05878 10.3583 4.05878 9.94161C4.05878 9.47666 4.05949 9.05218 4.10565 8.66998ZM20.3603 12.9897C20.5558 12.7723 20.538 12.4376 20.3205 12.2421C20.1031 12.0466 19.7684 12.0644 19.5729 12.2819C19.4582 12.4095 19.2694 12.5218 18.8817 12.5218C18.5893 12.5218 18.3523 12.7589 18.3523 13.0512V14.3418C18.3523 14.6342 18.5893 14.8712 18.8817 14.8712C19.174 14.8712 19.4111 14.6342 19.4111 14.3418V13.5272C19.7933 13.4445 20.1122 13.2657 20.3603 12.9897ZM4.42629 12.2819C4.23083 12.0644 3.89611 12.0466 3.67868 12.2421C3.46124 12.4376 3.44343 12.7723 3.63889 12.9897C3.88698 13.2657 4.20594 13.4445 4.58817 13.5272V14.3418C4.58817 14.6342 4.82518 14.8712 5.11756 14.8712C5.40993 14.8712 5.64694 14.6342 5.64694 14.3418V13.0512C5.64694 12.7589 5.40993 12.5218 5.11756 12.5218C4.72987 12.5218 4.541 12.4095 4.42629 12.2819ZM5.64694 16.0625C5.64694 15.7701 5.40993 15.5331 5.11756 15.5331C4.82518 15.5331 4.58817 15.7701 4.58817 16.0625V17.3531C4.58817 17.7849 4.69197 18.194 4.87646 18.5553C5.00941 18.8157 5.32828 18.9191 5.58868 18.7861C5.84908 18.6532 5.9524 18.3343 5.81945 18.0739C5.70931 17.8582 5.64694 17.6137 5.64694 17.3531V16.0625ZM19.4111 16.0625C19.4111 15.7701 19.174 15.5331 18.8817 15.5331C18.5893 15.5331 18.3523 15.7701 18.3523 16.0625V17.3531C18.3523 17.6137 18.2899 17.8582 18.1798 18.0739C18.0468 18.3343 18.1501 18.6532 18.4105 18.7861C18.6709 18.9191 18.9898 18.8157 19.1228 18.5553C19.3072 18.194 19.4111 17.7849 19.4111 17.3531V16.0625ZM6.51427 18.7687C6.25387 18.6358 5.935 18.7391 5.80206 18.9995C5.66911 19.2599 5.77243 19.5788 6.03283 19.7117C6.39419 19.8962 6.8033 20 7.23511 20H8.66446C8.95684 20 9.19385 19.763 9.19385 19.4706C9.19385 19.1782 8.95684 18.9412 8.66446 18.9412H7.23511C6.97451 18.9412 6.73001 18.8789 6.51427 18.7687ZM17.9664 19.7117C18.2268 19.5788 18.3301 19.2599 18.1972 18.9995C18.0642 18.7391 17.7453 18.6358 17.485 18.7687C17.2692 18.8789 17.0247 18.9412 16.7641 18.9412H15.3348C15.0424 18.9412 14.8054 19.1782 14.8054 19.4706C14.8054 19.763 15.0424 20 15.3348 20H16.7641C17.1959 20 17.605 19.8962 17.9664 19.7117ZM10.5703 18.9412C10.2779 18.9412 10.0409 19.1782 10.0409 19.4706C10.0409 19.763 10.2779 20 10.5703 20H13.429C13.7213 20 13.9584 19.763 13.9584 19.4706C13.9584 19.1782 13.7213 18.9412 13.429 18.9412H10.5703ZM7.76497 3.05878C8.31472 3.05878 8.82201 3.23047 9.28504 3.53489C9.52934 3.6955 9.85759 3.62766 10.0182 3.38336C10.1788 3.13905 10.111 2.8108 9.86668 2.65018C9.25452 2.24772 8.54798 2 7.76497 2C7.24316 2 6.7718 2.12296 6.37135 2.34465C6.11555 2.48625 6.02298 2.8084 6.16459 3.0642C6.30619 3.31999 6.62835 3.41256 6.88414 3.27096C7.11871 3.1411 7.41206 3.05878 7.76497 3.05878ZM12.5292 10.0295C12.5292 9.73709 12.2922 9.50007 11.9998 9.50007C11.7074 9.50007 11.4704 9.73709 11.4704 10.0295V12.5889H9C8.70762 12.5889 8.47061 12.8259 8.47061 13.1182C8.47061 13.4106 8.70762 13.6476 9 13.6476H11.4704V16.0001C11.4704 16.2924 11.7074 16.5295 11.9998 16.5295C12.2922 16.5295 12.5292 16.2924 12.5292 16.0001V13.6476H15C15.2924 13.6476 15.5294 13.4106 15.5294 13.1182C15.5294 12.8259 15.2924 12.5889 15 12.5889H12.5292V10.0295Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Submissions</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/requests"}
                  >
                    <Tab active={pathname.includes("requests")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.5 7C3.5 6.17157 4.17157 5.5 5 5.5H19C19.8284 5.5 20.5 6.17157 20.5 7V15C20.5 15.8284 19.8284 16.5 19 16.5H14.8284C14.1654 16.5 13.5295 16.7634 13.0607 17.2322L9.14645 21.1464C8.95118 21.3417 8.95118 21.6583 9.14645 21.8536C9.34171 22.0488 9.65829 22.0488 9.85355 21.8536L13.7678 17.9393C14.0491 17.658 14.4306 17.5 14.8284 17.5H19C20.3807 17.5 21.5 16.3807 21.5 15V7C21.5 5.61929 20.3807 4.5 19 4.5H5C3.61929 4.5 2.5 5.61929 2.5 7V15C2.5 16.3807 3.61929 17.5 5 17.5H8.5C8.77614 17.5 9 17.2761 9 17C9 16.7239 8.77614 16.5 8.5 16.5H5C4.17157 16.5 3.5 15.8284 3.5 15V7ZM8 10.5C7.72386 10.5 7.5 10.7239 7.5 11C7.5 11.2761 7.72386 11.5 8 11.5H8.01C8.28614 11.5 8.51 11.2761 8.51 11C8.51 10.7239 8.28614 10.5 8.01 10.5H8ZM12 10.5C11.7239 10.5 11.5 10.7239 11.5 11C11.5 11.2761 11.7239 11.5 12 11.5H12.01C12.2861 11.5 12.51 11.2761 12.51 11C12.51 10.7239 12.2861 10.5 12.01 10.5H12ZM16 10.5C15.7239 10.5 15.5 10.7239 15.5 11C15.5 11.2761 15.7239 11.5 16 11.5H16.01C16.2861 11.5 16.51 11.2761 16.51 11C16.51 10.7239 16.2861 10.5 16.01 10.5H16Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Requests</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => setShow(true)}
                    to={"/personal_dashboard/approvals"}
                  >
                    <Tab active={pathname.includes("approvals")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="#a8a8a8"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H6ZM6 4H12V9C12 9.55228 12.4477 10 13 10H18V20H6V4ZM14 4.41421L17.5858 8H14V4.41421ZM10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071L8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929C8.68342 11.9024 9.31658 11.9024 9.70711 12.2929L10 12.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L10.7071 14.7071Z"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Approvals</span>
                    </Tab>
                  </Link>


                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/personal_dashboard/feedbacks"}
                  >
                    <Tab active={pathname.includes("feedbacks")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.93303 6.87691C7.54534 6.49622 8.2922 6.39841 8.98189 6.60861L14.0119 8.14162C14.7016 8.35184 15.0414 9.12775 14.728 9.77719C14.4842 10.2825 13.9173 10.5451 13.3742 10.4044L10.8502 9.75052C10.7993 9.7368 10.7479 9.73148 10.6976 9.73379C10.546 9.74065 10.4056 9.81667 10.3167 9.93809C10.2841 9.98266 10.2584 10.0333 10.2417 10.089C10.2249 10.1446 10.2182 10.201 10.2208 10.2562C10.2299 10.4585 10.3623 10.641 10.5614 10.7075L12.5717 11.4019C13.2408 11.633 13.9643 11.6558 14.6466 11.4672L20.0238 9.98134C20.4014 9.877 20.804 10.0182 21.0337 10.3356C21.3423 10.7619 21.2399 11.3585 20.8069 11.6577L14.4845 16.0254C13.8754 16.4461 13.1112 16.5753 12.3977 16.3781L6.90309 14.8598C6.59945 14.7759 6.28588 14.7334 5.97087 14.7334H3.48264C3.2065 14.7334 2.98264 14.9573 2.98264 15.2334C2.98264 15.5095 3.2065 15.7334 3.48264 15.7334H5.97087C6.19588 15.7334 6.41986 15.7638 6.63674 15.8237L12.1313 17.342C13.1303 17.6181 14.2002 17.4372 15.0529 16.8481L21.3753 12.4804C22.2698 11.8625 22.4812 10.6299 21.8438 9.74927C21.3693 9.09369 20.5375 8.80191 19.7574 9.01746L15.657 10.1505C16.187 8.96161 15.5582 7.5675 14.3034 7.18506L9.27343 5.65205C8.30786 5.35777 7.26226 5.4947 6.40503 6.02767L2.73613 8.30878C2.50161 8.45459 2.4297 8.76289 2.57551 8.99741C2.72131 9.23192 3.02962 9.30383 3.26413 9.15802L6.93303 6.87691Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Feedback</span>
                    </Tab>
                  </Link>

                  {userDetails.user?.also_manager && (
                    <Link
                      onClick={() => {
                        setShow(true);
                      }}
                      to={`/personal_dashboard/teams/${userDetails.user.id}`}
                    >
                      <Tab
                        active={
                          pathname.includes("teams") ||
                          pathname.includes("team_services")
                        }
                      >
                        <div className="icon-wrapp">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12 9.57895C13.5406 9.57895 14.7895 8.33006 14.7895 6.78947C14.7895 5.24889 13.5406 4 12 4C10.4594 4 9.21053 5.24889 9.21053 6.78947C9.21053 8.33006 10.4594 9.57895 12 9.57895ZM12 10.5789C14.0929 10.5789 15.7895 8.88234 15.7895 6.78947C15.7895 4.69661 14.0929 3 12 3C9.90713 3 8.21053 4.69661 8.21053 6.78947C8.21053 8.88234 9.90713 10.5789 12 10.5789ZM6.39261 4.83338C6.30059 4.57302 6.01493 4.43656 5.75457 4.52858C4.68715 4.90586 3.92119 5.92382 3.92119 7.12197C3.92119 8.53781 4.99074 9.70316 6.36625 9.85521C6.64072 9.88555 6.88782 9.68765 6.91816 9.41318C6.94851 9.13871 6.7506 8.89161 6.47613 8.86127C5.60167 8.7646 4.92119 8.02241 4.92119 7.12197C4.92119 6.36079 5.40744 5.7119 6.08781 5.47142C6.34817 5.3794 6.48463 5.09373 6.39261 4.83338ZM18.2454 4.52858C17.9851 4.43656 17.6994 4.57302 17.6074 4.83338C17.5154 5.09373 17.6518 5.3794 17.9122 5.47142C18.5926 5.7119 19.0788 6.36079 19.0788 7.12197C19.0788 8.02241 18.3983 8.7646 17.5239 8.86127C17.2494 8.89161 17.0515 9.13871 17.0818 9.41318C17.1122 9.68765 17.3593 9.88555 17.6337 9.85521C19.0093 9.70316 20.0788 8.53781 20.0788 7.12197C20.0788 5.92382 19.3129 4.90586 18.2454 4.52858ZM18.6466 11.6511C18.373 11.6137 18.1208 11.8052 18.0834 12.0788C18.046 12.3524 18.2375 12.6045 18.5111 12.6419C20.4816 12.9114 22 14.6022 22 16.6468C22 17.2068 21.546 17.6609 20.9859 17.6609C20.7097 17.6609 20.4859 17.8847 20.4859 18.1609C20.4859 18.437 20.7097 18.6609 20.9859 18.6609C22.0983 18.6609 23 17.7591 23 16.6468C23 14.0954 21.1056 11.9874 18.6466 11.6511ZM5.35345 11.6511C5.62704 11.6137 5.87917 11.8052 5.91658 12.0788C5.95399 12.3524 5.76253 12.6045 5.48893 12.6419C3.51842 12.9114 2 14.6022 2 16.6468C2 17.2068 2.45404 17.6609 3.01412 17.6609C3.29026 17.6609 3.51412 17.8847 3.51412 18.1609C3.51412 18.437 3.29026 18.6609 3.01412 18.6609C1.90175 18.6609 1 17.7591 1 16.6468C1 14.0954 2.89437 11.9874 5.35345 11.6511ZM11.3684 11.9737C7.77858 11.9737 4.86843 14.8839 4.86843 18.4737V19C4.86843 20.3807 5.98772 21.5 7.36843 21.5H16.6316C18.0123 21.5 19.1316 20.3807 19.1316 19V18.4737C19.1316 14.8839 16.2214 11.9737 12.6316 11.9737H11.3684ZM5.86843 18.4737C5.86843 15.4361 8.33086 12.9737 11.3684 12.9737H12.6316C15.6691 12.9737 18.1316 15.4361 18.1316 18.4737V19C18.1316 19.8284 17.46 20.5 16.6316 20.5H7.36843C6.54 20.5 5.86843 19.8284 5.86843 19V18.4737Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <span className="font-bold text-[14px]">Team</span>
                      </Tab>
                    </Link>
                  )}
                </div>
              ) : pathname.includes("company_dashboard") ? (
                <div
                  className={`animation scrollbar-hide flex flex-col gap-[8px] sm:mt-[20px] custom_main_height`}
                >
                  {(userDetails.user?.general &&
                    userDetails.user?.single_service_user) || (
                    <>
                      {!(
                        userDetails.user?.general &&
                        userDetails.user?.multi_service_user
                      ) && (
                        <Link
                          onClick={() => {
                            setShow(true);
                          }}
                          to={"/company_dashboard/home"}
                        >
                          <Tab active={pathname.includes("home")}>
                            <div className="icon-wrapp">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12.3536 1.64645C12.1583 1.45118 11.8417 1.45118 11.6465 1.64645L2.64646 10.6464C2.50346 10.7894 2.46068 11.0045 2.53807 11.1913C2.61547 11.3782 2.79778 11.5 3.00001 11.5H4.50001V18C4.50001 18.663 4.76341 19.2989 5.23225 19.7678C5.70109 20.2366 6.33697 20.5 7.00001 20.5H9.00002H15H17C17.6631 20.5 18.2989 20.2366 18.7678 19.7678C19.2366 19.2989 19.5 18.663 19.5 18V11.5H21C21.2022 11.5 21.3846 11.3782 21.462 11.1913C21.5393 11.0045 21.4966 10.7894 21.3536 10.6464L12.3536 1.64645ZM15.5 19.5H17C17.3978 19.5 17.7794 19.342 18.0607 19.0607C18.342 18.7794 18.5 18.3978 18.5 18V11C18.5 10.7239 18.7239 10.5 19 10.5H19.7929L12 2.70711L4.20712 10.5H5.00001C5.27616 10.5 5.50002 10.7239 5.50002 11V18C5.50002 18.3978 5.65805 18.7794 5.93935 19.0607C6.22066 19.342 6.60219 19.5 7.00001 19.5H8.50002V14C8.50002 13.337 8.76341 12.7011 9.23225 12.2322C9.70109 11.7634 10.337 11.5 11 11.5H13C13.6631 11.5 14.2989 11.7634 14.7678 12.2322C15.2366 12.7011 15.5 13.337 15.5 14V19.5ZM9.50002 19.5V14C9.50002 13.6022 9.65805 13.2206 9.93936 12.9393C10.2207 12.658 10.6022 12.5 11 12.5H13C13.3978 12.5 13.7794 12.658 14.0607 12.9393C14.342 13.2206 14.5 13.6022 14.5 14V19.5H9.50002Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <span className="font-bold text-[14px]">Home</span>
                          </Tab>
                        </Link>
                      )}
                      {/*
                      <Link
                        onClick={() => {
                          setShow(true);
                        }}
                        to={"/company_dashboard/notifications"}
                      >
                        <Tab
                          active={
                            pathname.includes("notification")
                          }
                        >
                          <div className="icon-wrapp relative">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              class="forced-outline"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M18 16V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2z"
                                stroke="currentColor"
                                stroke-width="1"
                              />
                            </svg>

                            {unreadCount > 0 && (
                              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
                                {unreadCount}
                              </span>
                            )}
                          </div>
                          <span className="font-bold text-[14px]">Notifications</span>
                        </Tab>
                      </Link>  */}

                      <Link
                        onClick={() => {
                          setShow(true);
                        }}
                        to={"/company_dashboard/services"}
                      >
                        <Tab active={pathname.includes("services")}>
                          <div className="icon-wrapp">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M13.8061 4.58786C13.322 5.11599 12.9338 5.78973 12.6754 6.5H16.059C16.4478 6.49066 16.7546 6.38859 16.9835 6.22148C17.2208 6.04835 17.4119 5.77833 17.5158 5.37517C17.7544 4.44988 17.1528 3.5 16 3.5C15.1786 3.5 14.4284 3.90893 13.8061 4.58786ZM11.3736 6.5C11.0986 5.78592 10.7108 5.11248 10.2338 4.58567C9.61904 3.90665 8.88615 3.5 8.06714 3.5C6.91439 3.5 6.31274 4.44988 6.55131 5.37517C6.65525 5.77833 6.84638 6.04835 7.08359 6.22148C7.31255 6.38859 7.61937 6.49066 8.00818 6.5H11.3736ZM12.02 5.48309C12.296 4.90975 12.6487 4.37054 13.0689 3.91214C13.8216 3.09107 14.8214 2.5 16 2.5C17.8472 2.5 18.8755 4.10681 18.4842 5.62483C18.3991 5.95474 18.2667 6.24905 18.0895 6.50157C19.4288 6.54872 20.5 7.64926 20.5 9V11C20.5 12.0252 19.883 12.9062 19 13.292V17C19 18.3807 17.8807 19.5 16.5 19.5H7.5C6.11929 19.5 5 18.3807 5 17V13.292C4.11705 12.9062 3.5 12.0252 3.5 11V9C3.5 7.62711 4.60664 6.51269 5.97656 6.50011C5.79993 6.24791 5.66787 5.9541 5.58297 5.62483C5.19159 4.10681 6.21989 2.5 8.06714 2.5C9.24812 2.5 10.2317 3.09335 10.9751 3.91451C11.3904 4.37323 11.7401 4.91194 12.02 5.48309ZM7.99749 7.5H6C5.17157 7.5 4.5 8.17157 4.5 9V11C4.5 11.8284 5.17157 12.5 6 12.5H11.5V7.5H8.06714V7.5007C8.04386 7.5007 8.02064 7.50047 7.99749 7.5ZM16 7.5007V7.5H12.5V12.5H18C18.8284 12.5 19.5 11.8284 19.5 11V9C19.5 8.17157 18.8284 7.5 18 7.5H16.0696C16.0465 7.50047 16.0233 7.5007 16 7.5007ZM12.5 13.5H18V17C18 17.8284 17.3284 18.5 16.5 18.5H12.5V13.5ZM11.5 13.5V18.5H7.5C6.67157 18.5 6 17.8284 6 17V13.5H11.5Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <span className="font-bold text-[14px]">
                            Services
                          </span>
                        </Tab>
                      </Link>
                      {(userDetails.user?.admin ||
                        userDetails.user?.is_evaluator ||
                        userDetails.user?.personal_expenses_owner) && (
                        <Link
                          onClick={() => {
                            setShow(true);
                          }}
                          to={"/company_dashboard/expenses"}
                        >
                          <Tab active={pathname.includes("expenses")}>
                            <div className="icon-wrapp">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M4.6665 8.00163C4.6665 6.1611 6.15846 4.66699 7.99984 4.66699H23.9998C25.8412 4.66699 27.3332 6.1611 27.3332 8.00163V26.7531C27.3332 27.8154 26.1486 28.4563 25.2602 27.864L23.1079 26.4292C22.8664 26.2681 22.5484 26.2819 22.3217 26.4633L20.5826 27.8546C19.8521 28.4389 18.8142 28.4389 18.0838 27.8546L16.4163 26.5206C16.1728 26.3258 15.8269 26.3258 15.5834 26.5206L13.9159 27.8546C13.1855 28.4389 12.1476 28.4389 11.4171 27.8546L9.67802 26.4633C9.45132 26.2819 9.13332 26.2681 8.89176 26.4292L6.73944 27.864C5.85112 28.4563 4.6665 27.8154 4.6665 26.7531V8.00163ZM7.99984 6.00033C6.89569 6.00033 5.99984 6.89664 5.99984 8.00163V26.7531L8.15216 25.3198C8.87684 24.8366 9.83085 24.878 10.5109 25.4221L12.25 26.8134C12.4935 27.0082 12.8395 27.0082 13.083 26.8134L14.7504 25.4794C15.4809 24.8951 16.5188 24.8951 17.2492 25.4794L18.9167 26.8134C19.1602 27.0082 19.5062 27.0082 19.7496 26.8134L21.4887 25.4221C22.1688 24.878 23.1228 24.8366 23.8475 25.3198L25.9992 26.7542L25.9998 8.00163C25.9998 6.89664 25.104 6.00033 23.9998 6.00033H7.99984ZM9.99984 12.0003C9.99984 11.6321 10.2983 11.3337 10.6665 11.3337H16.6665C17.0347 11.3337 17.3332 11.6321 17.3332 12.0003C17.3332 12.3685 17.0347 12.667 16.6665 12.667H10.6665C10.2983 12.667 9.99984 12.3685 9.99984 12.0003ZM19.9998 12.0003C19.9998 11.6321 20.2983 11.3337 20.6665 11.3337H21.3332C21.7014 11.3337 21.9998 11.6321 21.9998 12.0003C21.9998 12.3685 21.7014 12.667 21.3332 12.667H20.6665C20.2983 12.667 19.9998 12.3685 19.9998 12.0003ZM9.99984 17.3337C9.99984 16.9655 10.2983 16.667 10.6665 16.667H21.3332C21.7014 16.667 21.9998 16.9655 21.9998 17.3337C21.9998 17.7018 21.7014 18.0003 21.3332 18.0003H10.6665C10.2983 18.0003 9.99984 17.7018 9.99984 17.3337Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <span className="font-bold text-[14px]">
                              Expenses
                            </span>
                          </Tab>
                        </Link>
                      )}

                      {!(
                        userDetails.user?.general &&
                        userDetails.user?.multi_service_user
                      ) && (
                        <Link
                          onClick={() => {
                            setShow(true);
                          }}
                          to={"/company_dashboard/service_submissions"}
                        >
                          <Tab
                            active={pathname.includes("service_submissions")}
                          >
                            <div className="icon-wrapp">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M14.7044 3.53243C15.1741 3.22938 15.6872 3.05878 16.2351 3.05878C16.5881 3.05878 16.8814 3.1411 17.116 3.27096C17.3718 3.41256 17.6939 3.31999 17.8355 3.0642C17.9771 2.8084 17.8846 2.48625 17.6288 2.34465C17.2283 2.12296 16.757 2 16.2351 2C15.4566 2 14.747 2.24493 14.1304 2.64277C13.8847 2.80128 13.814 3.12894 13.9726 3.37462C14.1311 3.62029 14.4587 3.69094 14.7044 3.53243ZM18.842 3.85607C18.7584 3.57593 18.4634 3.41667 18.1833 3.50035C17.9031 3.58403 17.7439 3.87897 17.8275 4.15911C17.9097 4.43407 17.9187 4.73924 17.8401 5.04417C17.7763 5.29143 17.6818 5.48968 17.5678 5.64678C17.438 5.82576 17.4365 6.05871 17.5458 6.23589H17.4372C17.2981 6.11172 17.0975 6.06495 16.9091 6.13102C16.717 6.19838 16.4922 6.23586 16.2351 6.23586C15.9428 6.23586 15.7058 6.47287 15.7058 6.76524C15.7058 7.05762 15.9428 7.29463 16.2351 7.29463C16.2863 7.29463 16.3371 7.29357 16.3876 7.29143C16.407 7.29357 16.4266 7.29466 16.4465 7.29466H18.3523C18.849 7.29466 19.1544 7.39412 19.348 7.519C19.5938 7.67745 19.9214 7.60671 20.0798 7.361C20.2383 7.11528 20.1675 6.78764 19.9218 6.62919C19.529 6.3759 19.0378 6.24904 18.4474 6.23686C18.6365 5.96745 18.7758 5.65564 18.8653 5.3085C18.9917 4.81824 18.9797 4.31688 18.842 3.85607ZM13.1729 5.23934C13.3168 4.98484 13.2272 4.66186 12.9727 4.51793C12.7182 4.374 12.3952 4.46363 12.2513 4.71813C12.1564 4.88583 12.0679 5.05766 11.986 5.23249C11.9047 5.06243 11.8177 4.89508 11.7251 4.73151C11.5811 4.47708 11.2581 4.3876 11.0036 4.53164C10.7492 4.67568 10.6597 4.9987 10.8038 5.25313C10.981 5.56611 11.1357 5.89723 11.2661 6.23589H10.0938C9.80144 6.23589 9.56442 6.4729 9.56442 6.76528C9.56442 7.05765 9.80144 7.29466 10.0938 7.29466H11.9893C11.9963 7.2948 12.0033 7.29481 12.0103 7.29466H13.9054C14.1978 7.29466 14.4348 7.05765 14.4348 6.76528C14.4348 6.4729 14.1978 6.23589 13.9054 6.23589H12.7149C12.8396 5.89296 12.9932 5.55697 13.1729 5.23934ZM6.43227 5.64678C6.56211 5.82576 6.56362 6.05871 6.45429 6.23589H6.56291C6.70201 6.11172 6.90263 6.06495 7.09103 6.13102C7.28314 6.19838 7.5079 6.23586 7.76497 6.23586C8.05734 6.23586 8.29436 6.47287 8.29436 6.76524C8.29436 7.05762 8.05734 7.29463 7.76497 7.29463C7.71363 7.29463 7.66257 7.29356 7.61183 7.2914C7.59243 7.29356 7.57272 7.29466 7.55275 7.29466H5.64694C5.1502 7.29466 4.84486 7.39412 4.65119 7.519C4.40547 7.67745 4.07783 7.60671 3.91938 7.361C3.76093 7.11528 3.83168 6.78764 4.07739 6.62919C4.47038 6.37577 4.96196 6.24891 5.55267 6.23684C5.36359 5.96743 5.22429 5.65563 5.13479 5.3085C5.00839 4.81824 5.02043 4.31688 5.15808 3.85607C5.24177 3.57593 5.5367 3.41667 5.81685 3.50035C6.09699 3.58403 6.25625 3.87897 6.17257 4.15911C6.09044 4.43407 6.08142 4.73924 6.16004 5.04417C6.22379 5.29143 6.31831 5.48968 6.43227 5.64678ZM20.9447 8.54303C20.9097 8.25277 20.6459 8.04588 20.3557 8.08094C20.0654 8.11599 19.8585 8.37972 19.8936 8.66998C19.9397 9.05218 19.9404 9.47666 19.9404 9.94161C19.9404 10.3583 19.9402 10.7459 19.9141 11.1008C19.8926 11.3924 20.1116 11.6461 20.4032 11.6676C20.6948 11.689 20.9486 11.47 20.97 11.1784C20.9992 10.7811 20.9992 10.3571 20.9992 9.9524V9.9247C20.9992 9.47888 20.9992 8.9945 20.9447 8.54303ZM4.10565 8.66998C4.1407 8.37972 3.93382 8.11599 3.64355 8.08094C3.35329 8.04588 3.08956 8.25277 3.05451 8.54303C2.99998 8.9945 2.99999 9.47887 3 9.92468V9.92469V9.95238V9.95255C3 10.3572 3 10.7812 3.02922 11.1784C3.05066 11.47 3.30442 11.689 3.59601 11.6676C3.8876 11.6461 4.10659 11.3924 4.08514 11.1008C4.05904 10.7459 4.05878 10.3583 4.05878 9.94161C4.05878 9.47666 4.05949 9.05218 4.10565 8.66998ZM20.3603 12.9897C20.5558 12.7723 20.538 12.4376 20.3205 12.2421C20.1031 12.0466 19.7684 12.0644 19.5729 12.2819C19.4582 12.4095 19.2694 12.5218 18.8817 12.5218C18.5893 12.5218 18.3523 12.7589 18.3523 13.0512V14.3418C18.3523 14.6342 18.5893 14.8712 18.8817 14.8712C19.174 14.8712 19.4111 14.6342 19.4111 14.3418V13.5272C19.7933 13.4445 20.1122 13.2657 20.3603 12.9897ZM4.42629 12.2819C4.23083 12.0644 3.89611 12.0466 3.67868 12.2421C3.46124 12.4376 3.44343 12.7723 3.63889 12.9897C3.88698 13.2657 4.20594 13.4445 4.58817 13.5272V14.3418C4.58817 14.6342 4.82518 14.8712 5.11756 14.8712C5.40993 14.8712 5.64694 14.6342 5.64694 14.3418V13.0512C5.64694 12.7589 5.40993 12.5218 5.11756 12.5218C4.72987 12.5218 4.541 12.4095 4.42629 12.2819ZM5.64694 16.0625C5.64694 15.7701 5.40993 15.5331 5.11756 15.5331C4.82518 15.5331 4.58817 15.7701 4.58817 16.0625V17.3531C4.58817 17.7849 4.69197 18.194 4.87646 18.5553C5.00941 18.8157 5.32828 18.9191 5.58868 18.7861C5.84908 18.6532 5.9524 18.3343 5.81945 18.0739C5.70931 17.8582 5.64694 17.6137 5.64694 17.3531V16.0625ZM19.4111 16.0625C19.4111 15.7701 19.174 15.5331 18.8817 15.5331C18.5893 15.5331 18.3523 15.7701 18.3523 16.0625V17.3531C18.3523 17.6137 18.2899 17.8582 18.1798 18.0739C18.0468 18.3343 18.1501 18.6532 18.4105 18.7861C18.6709 18.9191 18.9898 18.8157 19.1228 18.5553C19.3072 18.194 19.4111 17.7849 19.4111 17.3531V16.0625ZM6.51427 18.7687C6.25387 18.6358 5.935 18.7391 5.80206 18.9995C5.66911 19.2599 5.77243 19.5788 6.03283 19.7117C6.39419 19.8962 6.8033 20 7.23511 20H8.66446C8.95684 20 9.19385 19.763 9.19385 19.4706C9.19385 19.1782 8.95684 18.9412 8.66446 18.9412H7.23511C6.97451 18.9412 6.73001 18.8789 6.51427 18.7687ZM17.9664 19.7117C18.2268 19.5788 18.3301 19.2599 18.1972 18.9995C18.0642 18.7391 17.7453 18.6358 17.485 18.7687C17.2692 18.8789 17.0247 18.9412 16.7641 18.9412H15.3348C15.0424 18.9412 14.8054 19.1782 14.8054 19.4706C14.8054 19.763 15.0424 20 15.3348 20H16.7641C17.1959 20 17.605 19.8962 17.9664 19.7117ZM10.5703 18.9412C10.2779 18.9412 10.0409 19.1782 10.0409 19.4706C10.0409 19.763 10.2779 20 10.5703 20H13.429C13.7213 20 13.9584 19.763 13.9584 19.4706C13.9584 19.1782 13.7213 18.9412 13.429 18.9412H10.5703ZM7.76497 3.05878C8.31472 3.05878 8.82201 3.23047 9.28504 3.53489C9.52934 3.6955 9.85759 3.62766 10.0182 3.38336C10.1788 3.13905 10.111 2.8108 9.86668 2.65018C9.25452 2.24772 8.54798 2 7.76497 2C7.24316 2 6.7718 2.12296 6.37135 2.34465C6.11555 2.48625 6.02298 2.8084 6.16459 3.0642C6.30619 3.31999 6.62835 3.41256 6.88414 3.27096C7.11871 3.1411 7.41206 3.05878 7.76497 3.05878ZM12.5292 10.0295C12.5292 9.73709 12.2922 9.50007 11.9998 9.50007C11.7074 9.50007 11.4704 9.73709 11.4704 10.0295V12.5889H9C8.70762 12.5889 8.47061 12.8259 8.47061 13.1182C8.47061 13.4106 8.70762 13.6476 9 13.6476H11.4704V16.0001C11.4704 16.2924 11.7074 16.5295 11.9998 16.5295C12.2922 16.5295 12.5292 16.2924 12.5292 16.0001V13.6476H15C15.2924 13.6476 15.5294 13.4106 15.5294 13.1182C15.5294 12.8259 15.2924 12.5889 15 12.5889H12.5292V10.0295Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <span className="font-bold text-[14px]">
                              Service Submissions
                            </span>
                          </Tab>
                        </Link>
                      )}
                      {!(
                        userDetails.user?.general &&
                        userDetails.user?.multi_service_user
                      ) && (
                        <Link
                          onClick={() => {
                            setShow(true);
                          }}
                          to={"/company_dashboard/employees"}
                        >
                          <Tab active={pathname.includes("employees")}>
                            <div className="icon-wrapp">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11 2.5C10.1716 2.5 9.5 3.17157 9.5 4C9.5 4.82843 10.1716 5.5 11 5.5H13C13.8284 5.5 14.5 4.82843 14.5 4C14.5 3.17157 13.8284 2.5 13 2.5H11ZM11 1.5C9.79052 1.5 8.78164 2.35888 8.55001 3.5H7C6.33696 3.5 5.70107 3.76339 5.23223 4.23223C4.76339 4.70107 4.5 5.33696 4.5 6V18C4.5 18.663 4.76339 19.2989 5.23223 19.7678C5.70107 20.2366 6.33696 20.5 7 20.5H17C17.663 20.5 18.2989 20.2366 18.7678 19.7678C19.2366 19.2989 19.5 18.663 19.5 18V6C19.5 5.33696 19.2366 4.70107 18.7678 4.23223C18.2989 3.76339 17.663 3.5 17 3.5H15.45C15.2184 2.35888 14.2095 1.5 13 1.5H11ZM17 4.5H15.45C15.2184 5.64112 14.2095 6.5 13 6.5H11C9.79052 6.5 8.78164 5.64112 8.55001 4.5H7C6.60218 4.5 6.22064 4.65804 5.93934 4.93934C5.65804 5.22064 5.5 5.60218 5.5 6V18C5.5 18.3978 5.65804 18.7794 5.93934 19.0607C6.22064 19.342 6.60218 19.5 7 19.5H17C17.3978 19.5 17.7794 19.342 18.0607 19.0607C18.342 18.7794 18.5 18.3978 18.5 18V6C18.5 5.60218 18.342 5.22064 18.0607 4.93934C17.7794 4.65804 17.3978 4.5 17 4.5ZM9.74998 10.75C9.74998 9.50736 10.7573 8.5 12 8.5C13.2426 8.5 14.25 9.50736 14.25 10.75C14.25 11.9926 13.2426 13 12 13C10.7573 13 9.74998 11.9926 9.74998 10.75ZM12 9.5C11.3096 9.5 10.75 10.0596 10.75 10.75C10.75 11.4404 11.3096 12 12 12C12.6903 12 13.25 11.4404 13.25 10.75C13.25 10.0596 12.6903 9.5 12 9.5ZM12 15.5C10.6753 15.5 9.52829 16.2095 8.934 17.2483C8.79687 17.488 8.4914 17.5711 8.25171 17.434C8.01202 17.2969 7.92888 16.9914 8.066 16.7517C8.83644 15.405 10.3127 14.5 12 14.5C13.6873 14.5 15.1636 15.405 15.934 16.7517C16.0711 16.9914 15.988 17.2969 15.7483 17.434C15.5086 17.5711 15.2031 17.488 15.066 17.2483C14.4717 16.2095 13.3247 15.5 12 15.5Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <span className="font-bold text-[14px]">
                              Employees
                            </span>
                          </Tab>
                        </Link>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div
                  className={` animation overflow-y-scroll scrollbar-hide flex flex-col gap-[8px] pt-[12px]`}
                >
                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/tasker/home"}
                  >
                    <Tab active={pathname.includes("home")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.3536 1.64645C12.1583 1.45118 11.8417 1.45118 11.6465 1.64645L2.64646 10.6464C2.50346 10.7894 2.46068 11.0045 2.53807 11.1913C2.61547 11.3782 2.79778 11.5 3.00001 11.5H4.50001V18C4.50001 18.663 4.76341 19.2989 5.23225 19.7678C5.70109 20.2366 6.33697 20.5 7.00001 20.5H9.00002H15H17C17.6631 20.5 18.2989 20.2366 18.7678 19.7678C19.2366 19.2989 19.5 18.663 19.5 18V11.5H21C21.2022 11.5 21.3846 11.3782 21.462 11.1913C21.5393 11.0045 21.4966 10.7894 21.3536 10.6464L12.3536 1.64645ZM15.5 19.5H17C17.3978 19.5 17.7794 19.342 18.0607 19.0607C18.342 18.7794 18.5 18.3978 18.5 18V11C18.5 10.7239 18.7239 10.5 19 10.5H19.7929L12 2.70711L4.20712 10.5H5.00001C5.27616 10.5 5.50002 10.7239 5.50002 11V18C5.50002 18.3978 5.65805 18.7794 5.93935 19.0607C6.22066 19.342 6.60219 19.5 7.00001 19.5H8.50002V14C8.50002 13.337 8.76341 12.7011 9.23225 12.2322C9.70109 11.7634 10.337 11.5 11 11.5H13C13.6631 11.5 14.2989 11.7634 14.7678 12.2322C15.2366 12.7011 15.5 13.337 15.5 14V19.5ZM9.50002 19.5V14C9.50002 13.6022 9.65805 13.2206 9.93936 12.9393C10.2207 12.658 10.6022 12.5 11 12.5H13C13.3978 12.5 13.7794 12.658 14.0607 12.9393C14.342 13.2206 14.5 13.6022 14.5 14V19.5H9.50002Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Home</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/tasker/services"}
                  >
                    <Tab active={pathname.includes("services")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8061 4.58786C13.322 5.11599 12.9338 5.78973 12.6754 6.5H16.059C16.4478 6.49066 16.7546 6.38859 16.9835 6.22148C17.2208 6.04835 17.4119 5.77833 17.5158 5.37517C17.7544 4.44988 17.1528 3.5 16 3.5C15.1786 3.5 14.4284 3.90893 13.8061 4.58786ZM11.3736 6.5C11.0986 5.78592 10.7108 5.11248 10.2338 4.58567C9.61904 3.90665 8.88615 3.5 8.06714 3.5C6.91439 3.5 6.31274 4.44988 6.55131 5.37517C6.65525 5.77833 6.84638 6.04835 7.08359 6.22148C7.31255 6.38859 7.61937 6.49066 8.00818 6.5H11.3736ZM12.02 5.48309C12.296 4.90975 12.6487 4.37054 13.0689 3.91214C13.8216 3.09107 14.8214 2.5 16 2.5C17.8472 2.5 18.8755 4.10681 18.4842 5.62483C18.3991 5.95474 18.2667 6.24905 18.0895 6.50157C19.4288 6.54872 20.5 7.64926 20.5 9V11C20.5 12.0252 19.883 12.9062 19 13.292V17C19 18.3807 17.8807 19.5 16.5 19.5H7.5C6.11929 19.5 5 18.3807 5 17V13.292C4.11705 12.9062 3.5 12.0252 3.5 11V9C3.5 7.62711 4.60664 6.51269 5.97656 6.50011C5.79993 6.24791 5.66787 5.9541 5.58297 5.62483C5.19159 4.10681 6.21989 2.5 8.06714 2.5C9.24812 2.5 10.2317 3.09335 10.9751 3.91451C11.3904 4.37323 11.7401 4.91194 12.02 5.48309ZM7.99749 7.5H6C5.17157 7.5 4.5 8.17157 4.5 9V11C4.5 11.8284 5.17157 12.5 6 12.5H11.5V7.5H8.06714V7.5007C8.04386 7.5007 8.02064 7.50047 7.99749 7.5ZM16 7.5007V7.5H12.5V12.5H18C18.8284 12.5 19.5 11.8284 19.5 11V9C19.5 8.17157 18.8284 7.5 18 7.5H16.0696C16.0465 7.50047 16.0233 7.5007 16 7.5007ZM12.5 13.5H18V17C18 17.8284 17.3284 18.5 16.5 18.5H12.5V13.5ZM11.5 13.5V18.5H7.5C6.67157 18.5 6 17.8284 6 17V13.5H11.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Services</span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/tasker/service_submissions"}
                  >
                    <Tab active={pathname.includes("service_submissions")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.7044 3.53243C15.1741 3.22938 15.6872 3.05878 16.2351 3.05878C16.5881 3.05878 16.8814 3.1411 17.116 3.27096C17.3718 3.41256 17.6939 3.31999 17.8355 3.0642C17.9771 2.8084 17.8846 2.48625 17.6288 2.34465C17.2283 2.12296 16.757 2 16.2351 2C15.4566 2 14.747 2.24493 14.1304 2.64277C13.8847 2.80128 13.814 3.12894 13.9726 3.37462C14.1311 3.62029 14.4587 3.69094 14.7044 3.53243ZM18.842 3.85607C18.7584 3.57593 18.4634 3.41667 18.1833 3.50035C17.9031 3.58403 17.7439 3.87897 17.8275 4.15911C17.9097 4.43407 17.9187 4.73924 17.8401 5.04417C17.7763 5.29143 17.6818 5.48968 17.5678 5.64678C17.438 5.82576 17.4365 6.05871 17.5458 6.23589H17.4372C17.2981 6.11172 17.0975 6.06495 16.9091 6.13102C16.717 6.19838 16.4922 6.23586 16.2351 6.23586C15.9428 6.23586 15.7058 6.47287 15.7058 6.76524C15.7058 7.05762 15.9428 7.29463 16.2351 7.29463C16.2863 7.29463 16.3371 7.29357 16.3876 7.29143C16.407 7.29357 16.4266 7.29466 16.4465 7.29466H18.3523C18.849 7.29466 19.1544 7.39412 19.348 7.519C19.5938 7.67745 19.9214 7.60671 20.0798 7.361C20.2383 7.11528 20.1675 6.78764 19.9218 6.62919C19.529 6.3759 19.0378 6.24904 18.4474 6.23686C18.6365 5.96745 18.7758 5.65564 18.8653 5.3085C18.9917 4.81824 18.9797 4.31688 18.842 3.85607ZM13.1729 5.23934C13.3168 4.98484 13.2272 4.66186 12.9727 4.51793C12.7182 4.374 12.3952 4.46363 12.2513 4.71813C12.1564 4.88583 12.0679 5.05766 11.986 5.23249C11.9047 5.06243 11.8177 4.89508 11.7251 4.73151C11.5811 4.47708 11.2581 4.3876 11.0036 4.53164C10.7492 4.67568 10.6597 4.9987 10.8038 5.25313C10.981 5.56611 11.1357 5.89723 11.2661 6.23589H10.0938C9.80144 6.23589 9.56442 6.4729 9.56442 6.76528C9.56442 7.05765 9.80144 7.29466 10.0938 7.29466H11.9893C11.9963 7.2948 12.0033 7.29481 12.0103 7.29466H13.9054C14.1978 7.29466 14.4348 7.05765 14.4348 6.76528C14.4348 6.4729 14.1978 6.23589 13.9054 6.23589H12.7149C12.8396 5.89296 12.9932 5.55697 13.1729 5.23934ZM6.43227 5.64678C6.56211 5.82576 6.56362 6.05871 6.45429 6.23589H6.56291C6.70201 6.11172 6.90263 6.06495 7.09103 6.13102C7.28314 6.19838 7.5079 6.23586 7.76497 6.23586C8.05734 6.23586 8.29436 6.47287 8.29436 6.76524C8.29436 7.05762 8.05734 7.29463 7.76497 7.29463C7.71363 7.29463 7.66257 7.29356 7.61183 7.2914C7.59243 7.29356 7.57272 7.29466 7.55275 7.29466H5.64694C5.1502 7.29466 4.84486 7.39412 4.65119 7.519C4.40547 7.67745 4.07783 7.60671 3.91938 7.361C3.76093 7.11528 3.83168 6.78764 4.07739 6.62919C4.47038 6.37577 4.96196 6.24891 5.55267 6.23684C5.36359 5.96743 5.22429 5.65563 5.13479 5.3085C5.00839 4.81824 5.02043 4.31688 5.15808 3.85607C5.24177 3.57593 5.5367 3.41667 5.81685 3.50035C6.09699 3.58403 6.25625 3.87897 6.17257 4.15911C6.09044 4.43407 6.08142 4.73924 6.16004 5.04417C6.22379 5.29143 6.31831 5.48968 6.43227 5.64678ZM20.9447 8.54303C20.9097 8.25277 20.6459 8.04588 20.3557 8.08094C20.0654 8.11599 19.8585 8.37972 19.8936 8.66998C19.9397 9.05218 19.9404 9.47666 19.9404 9.94161C19.9404 10.3583 19.9402 10.7459 19.9141 11.1008C19.8926 11.3924 20.1116 11.6461 20.4032 11.6676C20.6948 11.689 20.9486 11.47 20.97 11.1784C20.9992 10.7811 20.9992 10.3571 20.9992 9.9524V9.9247C20.9992 9.47888 20.9992 8.9945 20.9447 8.54303ZM4.10565 8.66998C4.1407 8.37972 3.93382 8.11599 3.64355 8.08094C3.35329 8.04588 3.08956 8.25277 3.05451 8.54303C2.99998 8.9945 2.99999 9.47887 3 9.92468V9.92469V9.95238V9.95255C3 10.3572 3 10.7812 3.02922 11.1784C3.05066 11.47 3.30442 11.689 3.59601 11.6676C3.8876 11.6461 4.10659 11.3924 4.08514 11.1008C4.05904 10.7459 4.05878 10.3583 4.05878 9.94161C4.05878 9.47666 4.05949 9.05218 4.10565 8.66998ZM20.3603 12.9897C20.5558 12.7723 20.538 12.4376 20.3205 12.2421C20.1031 12.0466 19.7684 12.0644 19.5729 12.2819C19.4582 12.4095 19.2694 12.5218 18.8817 12.5218C18.5893 12.5218 18.3523 12.7589 18.3523 13.0512V14.3418C18.3523 14.6342 18.5893 14.8712 18.8817 14.8712C19.174 14.8712 19.4111 14.6342 19.4111 14.3418V13.5272C19.7933 13.4445 20.1122 13.2657 20.3603 12.9897ZM4.42629 12.2819C4.23083 12.0644 3.89611 12.0466 3.67868 12.2421C3.46124 12.4376 3.44343 12.7723 3.63889 12.9897C3.88698 13.2657 4.20594 13.4445 4.58817 13.5272V14.3418C4.58817 14.6342 4.82518 14.8712 5.11756 14.8712C5.40993 14.8712 5.64694 14.6342 5.64694 14.3418V13.0512C5.64694 12.7589 5.40993 12.5218 5.11756 12.5218C4.72987 12.5218 4.541 12.4095 4.42629 12.2819ZM5.64694 16.0625C5.64694 15.7701 5.40993 15.5331 5.11756 15.5331C4.82518 15.5331 4.58817 15.7701 4.58817 16.0625V17.3531C4.58817 17.7849 4.69197 18.194 4.87646 18.5553C5.00941 18.8157 5.32828 18.9191 5.58868 18.7861C5.84908 18.6532 5.9524 18.3343 5.81945 18.0739C5.70931 17.8582 5.64694 17.6137 5.64694 17.3531V16.0625ZM19.4111 16.0625C19.4111 15.7701 19.174 15.5331 18.8817 15.5331C18.5893 15.5331 18.3523 15.7701 18.3523 16.0625V17.3531C18.3523 17.6137 18.2899 17.8582 18.1798 18.0739C18.0468 18.3343 18.1501 18.6532 18.4105 18.7861C18.6709 18.9191 18.9898 18.8157 19.1228 18.5553C19.3072 18.194 19.4111 17.7849 19.4111 17.3531V16.0625ZM6.51427 18.7687C6.25387 18.6358 5.935 18.7391 5.80206 18.9995C5.66911 19.2599 5.77243 19.5788 6.03283 19.7117C6.39419 19.8962 6.8033 20 7.23511 20H8.66446C8.95684 20 9.19385 19.763 9.19385 19.4706C9.19385 19.1782 8.95684 18.9412 8.66446 18.9412H7.23511C6.97451 18.9412 6.73001 18.8789 6.51427 18.7687ZM17.9664 19.7117C18.2268 19.5788 18.3301 19.2599 18.1972 18.9995C18.0642 18.7391 17.7453 18.6358 17.485 18.7687C17.2692 18.8789 17.0247 18.9412 16.7641 18.9412H15.3348C15.0424 18.9412 14.8054 19.1782 14.8054 19.4706C14.8054 19.763 15.0424 20 15.3348 20H16.7641C17.1959 20 17.605 19.8962 17.9664 19.7117ZM10.5703 18.9412C10.2779 18.9412 10.0409 19.1782 10.0409 19.4706C10.0409 19.763 10.2779 20 10.5703 20H13.429C13.7213 20 13.9584 19.763 13.9584 19.4706C13.9584 19.1782 13.7213 18.9412 13.429 18.9412H10.5703ZM7.76497 3.05878C8.31472 3.05878 8.82201 3.23047 9.28504 3.53489C9.52934 3.6955 9.85759 3.62766 10.0182 3.38336C10.1788 3.13905 10.111 2.8108 9.86668 2.65018C9.25452 2.24772 8.54798 2 7.76497 2C7.24316 2 6.7718 2.12296 6.37135 2.34465C6.11555 2.48625 6.02298 2.8084 6.16459 3.0642C6.30619 3.31999 6.62835 3.41256 6.88414 3.27096C7.11871 3.1411 7.41206 3.05878 7.76497 3.05878ZM12.5292 10.0295C12.5292 9.73709 12.2922 9.50007 11.9998 9.50007C11.7074 9.50007 11.4704 9.73709 11.4704 10.0295V12.5889H9C8.70762 12.5889 8.47061 12.8259 8.47061 13.1182C8.47061 13.4106 8.70762 13.6476 9 13.6476H11.4704V16.0001C11.4704 16.2924 11.7074 16.5295 11.9998 16.5295C12.2922 16.5295 12.5292 16.2924 12.5292 16.0001V13.6476H15C15.2924 13.6476 15.5294 13.4106 15.5294 13.1182C15.5294 12.8259 15.2924 12.5889 15 12.5889H12.5292V10.0295Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">
                        Service Submissions
                      </span>
                    </Tab>
                  </Link>

                  <Link
                    onClick={() => {
                      setShow(true);
                    }}
                    to={"/tasker/employees"}
                  >
                    <Tab active={pathname.includes("employees")}>
                      <div className="icon-wrapp">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11 2.5C10.1716 2.5 9.5 3.17157 9.5 4C9.5 4.82843 10.1716 5.5 11 5.5H13C13.8284 5.5 14.5 4.82843 14.5 4C14.5 3.17157 13.8284 2.5 13 2.5H11ZM11 1.5C9.79052 1.5 8.78164 2.35888 8.55001 3.5H7C6.33696 3.5 5.70107 3.76339 5.23223 4.23223C4.76339 4.70107 4.5 5.33696 4.5 6V18C4.5 18.663 4.76339 19.2989 5.23223 19.7678C5.70107 20.2366 6.33696 20.5 7 20.5H17C17.663 20.5 18.2989 20.2366 18.7678 19.7678C19.2366 19.2989 19.5 18.663 19.5 18V6C19.5 5.33696 19.2366 4.70107 18.7678 4.23223C18.2989 3.76339 17.663 3.5 17 3.5H15.45C15.2184 2.35888 14.2095 1.5 13 1.5H11ZM17 4.5H15.45C15.2184 5.64112 14.2095 6.5 13 6.5H11C9.79052 6.5 8.78164 5.64112 8.55001 4.5H7C6.60218 4.5 6.22064 4.65804 5.93934 4.93934C5.65804 5.22064 5.5 5.60218 5.5 6V18C5.5 18.3978 5.65804 18.7794 5.93934 19.0607C6.22064 19.342 6.60218 19.5 7 19.5H17C17.3978 19.5 17.7794 19.342 18.0607 19.0607C18.342 18.7794 18.5 18.3978 18.5 18V6C18.5 5.60218 18.342 5.22064 18.0607 4.93934C17.7794 4.65804 17.3978 4.5 17 4.5ZM9.74998 10.75C9.74998 9.50736 10.7573 8.5 12 8.5C13.2426 8.5 14.25 9.50736 14.25 10.75C14.25 11.9926 13.2426 13 12 13C10.7573 13 9.74998 11.9926 9.74998 10.75ZM12 9.5C11.3096 9.5 10.75 10.0596 10.75 10.75C10.75 11.4404 11.3096 12 12 12C12.6903 12 13.25 11.4404 13.25 10.75C13.25 10.0596 12.6903 9.5 12 9.5ZM12 15.5C10.6753 15.5 9.52829 16.2095 8.934 17.2483C8.79687 17.488 8.4914 17.5711 8.25171 17.434C8.01202 17.2969 7.92888 16.9914 8.066 16.7517C8.83644 15.405 10.3127 14.5 12 14.5C13.6873 14.5 15.1636 15.405 15.934 16.7517C16.0711 16.9914 15.988 17.2969 15.7483 17.434C15.5086 17.5711 15.2031 17.488 15.066 17.2483C14.4717 16.2095 13.3247 15.5 12 15.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span className="font-bold text-[14px]">Employees</span>
                    </Tab>
                  </Link>
                </div>
              )}

              <div
                className={`${
                  open
                    ? "h-[300px] 3xl:h-[250px]"
                    : "h-[378px] 3xl:h-[325px] 4xl:h-[270px] 6xl:h-[378px] "
                } animation flex flex-col gap-[8px] mt-[auto] tb-sd-rs-is desktop_height`}
              >
                <div
                  className={cn(
                    `animation pl-[16px] pt-[24px] pr-[16px] pb-[16px]`,
                    {
                      "max-h-[64px]": !open,
                      "!py-0": isGeneralNCompany,
                      hidden:
                        isGeneralNCompany &&
                        !CompanyState?.servicesData?.company_services?.length,
                    }
                  )}
                >
                  <div className="h-[1px] w-full bg-[#363D50]" />
                </div>
                <div>
                  <Tab
                    active={popup}
                    onClick={() => {
                      setPopup(true);
                      setState(22);
                      setShow(true);
                    }}
                  >
                    <div className="icon-wrapp">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.7075 21.0048L8.66181 21.0003L8.61591 21C8.34481 20.9984 8.08162 20.9087 7.86595 20.7444L5.79721 19.2054C5.52536 18.9903 5.34504 18.68 5.29285 18.3371C5.24018 17.9909 5.32209 17.6378 5.52168 17.3501L5.52799 17.3407C5.79937 16.94 5.97183 16.4807 6.03122 16.0004C6.09061 15.5201 6.03528 15.0326 5.86969 14.5778L5.81974 14.4446C5.69718 14.0338 5.48279 13.6559 5.19256 13.3398C4.89162 13.012 4.51762 12.7597 4.10091 12.6036L3.93122 12.54H3.77709C3.50198 12.4138 3.27627 12.1974 3.13892 11.9246C2.98024 11.6093 2.95235 11.2443 3.06124 10.9086L3.89272 8.27217L3.90001 8.24306C3.94087 8.08001 4.0161 7.92756 4.12065 7.79594C4.2252 7.66431 4.35667 7.55655 4.50625 7.47985L4.50803 7.47894C4.64512 7.4083 4.79512 7.36622 4.94895 7.35523C5.10278 7.34424 5.25723 7.36462 5.40297 7.41505L5.41104 7.41777C5.86326 7.56996 6.34582 7.60941 6.81676 7.53268C7.2877 7.45596 7.7328 7.2654 8.11333 6.97753L8.25676 6.8672L8.26371 6.86166C8.60756 6.58729 8.88546 6.23926 9.07693 5.84321C9.26839 5.44717 9.36855 5.01321 9.37 4.57331L9.37001 4.33L9.37 4.32561C9.36847 3.97747 9.50453 3.64283 9.74856 3.39454C9.99129 3.14757 10.3213 3.00593 10.6674 3H13.2085C13.374 3.0006 13.5379 3.03382 13.6906 3.09778C13.8432 3.16166 13.9816 3.25495 14.0981 3.37233C14.3519 3.63105 14.4928 3.97981 14.49 4.34225V4.6218C14.4837 5.05076 14.5775 5.47534 14.7639 5.8618C14.9519 6.25133 15.2288 6.59123 15.5722 6.8541L15.5819 6.86154L15.6966 6.94492C16.0486 7.20723 16.4584 7.38115 16.8917 7.45201C17.3265 7.5231 17.772 7.48831 18.1905 7.35059L18.1939 7.34947L18.5278 7.24147L18.5347 7.23921C18.6953 7.18597 18.8649 7.16563 19.0336 7.17938C19.2022 7.19314 19.3663 7.24072 19.5162 7.31929C19.666 7.39786 19.7985 7.5058 19.9058 7.63668C20.013 7.76756 20.0928 7.91869 20.1403 8.08107L20.143 8.09013L20.9359 10.6195C21.0412 10.9551 21.0124 11.3185 20.8556 11.6333C20.699 11.9474 20.4272 12.1888 20.0968 12.3071L20.0945 12.3079L19.9082 12.3732C19.4626 12.521 19.0597 12.7751 18.7343 13.1137C18.4068 13.4546 18.1678 13.8706 18.0385 14.3253C17.9195 14.74 17.8913 15.1755 17.956 15.6021C18.0207 16.0293 18.1769 16.4374 18.4139 16.7986L18.4192 16.8067L18.6847 17.1947L18.6865 17.1974C18.8865 17.4875 18.9678 17.8432 18.9139 18.1914C18.8601 18.5392 18.6754 18.8532 18.3978 19.0693L18.3966 19.0702L16.3925 20.6157L16.3911 20.6168C16.257 20.719 16.1035 20.7928 15.9399 20.8337C15.7757 20.8747 15.6049 20.8817 15.4379 20.8542C15.2709 20.8267 15.1113 20.7654 14.9689 20.6739C14.8266 20.5824 14.7044 20.4627 14.61 20.3223L14.6036 20.3127L14.484 20.1433C14.2274 19.7623 13.8795 19.4516 13.4718 19.2396C13.0596 19.0253 12.5998 18.9189 12.1354 18.9303L12.1341 18.9303C11.6954 18.9417 11.2655 19.056 10.8791 19.2641C10.4927 19.4721 10.1606 19.7682 9.90961 20.1282L9.67385 20.4665L9.66827 20.4748C9.57351 20.6168 9.45069 20.7378 9.30737 20.8305C9.17386 20.9169 9.02519 20.9769 8.86938 21.0075C8.81546 21.0109 8.76132 21.01 8.7075 21.0048ZM4.30423 18.4875C4.39536 19.0863 4.71231 19.6276 5.19 20L7.26 21.54C7.64822 21.8357 8.12203 21.9971 8.61 22C8.73969 22.0127 8.87031 22.0127 9 22C9.30301 21.9493 9.59241 21.8371 9.85039 21.6702C10.1084 21.5034 10.3294 21.2855 10.5 21.03L10.73 20.7C10.8913 20.4686 11.1048 20.2783 11.3532 20.1445C11.6016 20.0108 11.878 19.9373 12.16 19.93C12.4556 19.9227 12.7481 19.9904 13.0104 20.1268C13.2727 20.2632 13.4962 20.4639 13.66 20.71L13.78 20.88C13.9505 21.1337 14.1711 21.3499 14.4283 21.5152C14.6855 21.6804 14.9738 21.7913 15.2755 21.8409C15.5771 21.8906 15.8857 21.878 16.1823 21.8039C16.4789 21.7297 16.7572 21.5957 17 21.41L19.01 19.86C19.49 19.4872 19.8092 18.945 19.9021 18.3444C19.9951 17.7438 19.8548 17.1304 19.51 16.63L19.25 16.25C19.092 16.0092 18.9878 15.7371 18.9447 15.4523C18.9015 15.1675 18.9204 14.8768 19 14.6C19.0845 14.3022 19.2409 14.0298 19.4554 13.8066C19.6698 13.5834 19.9358 13.4163 20.23 13.32L20.43 13.25C21.005 13.0452 21.4784 12.6256 21.7506 12.0793C22.0228 11.533 22.0728 10.9024 21.89 10.32L21.1 7.8C21.0147 7.50876 20.8716 7.23767 20.6793 7.00292C20.487 6.76817 20.2493 6.57456 19.9805 6.43364C19.7118 6.29272 19.4174 6.20737 19.1149 6.1827C18.8124 6.15802 18.5081 6.19451 18.22 6.29L17.88 6.4C17.6136 6.48805 17.33 6.51039 17.0531 6.46511C16.7762 6.41984 16.5144 6.3083 16.29 6.14L16.18 6.06C15.961 5.89237 15.7844 5.67562 15.6646 5.42723C15.5447 5.17884 15.4849 4.90575 15.49 4.63V4.35C15.4949 3.72202 15.2503 3.11779 14.81 2.67C14.6006 2.45845 14.3514 2.29036 14.0768 2.17538C13.8023 2.0604 13.5077 2.0008 13.21 2H10.66C10.0482 2.00791 9.46425 2.25719 9.03535 2.69358C8.60645 3.12997 8.36732 3.71813 8.37 4.33V4.57C8.36904 4.86027 8.30296 5.14663 8.17662 5.40796C8.05027 5.6693 7.8669 5.89895 7.64 6.08L7.51 6.18C7.25935 6.36962 6.96617 6.49516 6.65596 6.5457C6.34575 6.59624 6.02789 6.57025 5.73 6.47C5.45642 6.37533 5.16647 6.33715 4.8777 6.35777C4.58893 6.3784 4.30736 6.4574 4.05 6.59C3.77366 6.73169 3.53078 6.93078 3.33762 7.17396C3.14446 7.41713 3.00549 7.69876 2.93 8L2.11 10.6C1.91985 11.1862 1.96861 11.8237 2.24571 12.3742C2.52281 12.9247 3.00588 13.3436 3.59 13.54H3.75C4.01946 13.641 4.26131 13.8041 4.45591 14.0161C4.65051 14.228 4.79238 14.4829 4.87 14.76L4.93 14.92C5.04148 15.2261 5.07876 15.5543 5.03878 15.8777C4.99879 16.201 4.88269 16.5102 4.7 16.78C4.35472 17.2777 4.21311 17.8887 4.30423 18.4875ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <span className="font-bold text-[14px]">Settings</span>
                  </Tab>
                  {/* <Tab active={false}>
                    <div className="icon-wrapp">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.83398 5.3335C3.83398 4.50507 4.50556 3.8335 5.33398 3.8335H19.9245C20.7529 3.8335 21.4245 4.50507 21.4245 5.3335V15.5049C21.4245 16.3334 20.7529 17.0049 19.9245 17.0049H15.8196C15.1565 17.0049 14.5206 17.2683 14.0518 17.7372L9.32329 22.4657C9.12803 22.6609 9.12803 22.9775 9.32329 23.1728C9.51855 23.368 9.83513 23.368 10.0304 23.1728L14.7589 18.4443C15.0402 18.163 15.4217 18.0049 15.8196 18.0049H19.9245C21.3052 18.0049 22.4245 16.8856 22.4245 15.5049V5.3335C22.4245 3.95278 21.3052 2.8335 19.9245 2.8335H5.33398C3.95327 2.8335 2.83398 3.95279 2.83398 5.3335V15.5049C2.83398 16.8856 3.95327 18.0049 5.33398 18.0049H8.49589C8.77203 18.0049 8.99589 17.7811 8.99589 17.5049C8.99589 17.2288 8.77203 17.0049 8.49589 17.0049H5.33398C4.50556 17.0049 3.83398 16.3334 3.83398 15.5049V5.3335ZM7.90541 9.91921C7.62927 9.91921 7.40541 10.1431 7.40541 10.4192C7.40541 10.6954 7.62927 10.9192 7.90541 10.9192H7.91722C8.19336 10.9192 8.41722 10.6954 8.41722 10.4192C8.41722 10.1431 8.19336 9.91921 7.91722 9.91921H7.90541ZM12.6292 9.91921C12.3531 9.91921 12.1292 10.1431 12.1292 10.4192C12.1292 10.6954 12.3531 10.9192 12.6292 10.9192H12.641C12.9172 10.9192 13.141 10.6954 13.141 10.4192C13.141 10.1431 12.9172 9.91921 12.641 9.91921H12.6292ZM17.353 9.91921C17.0769 9.91921 16.853 10.1431 16.853 10.4192C16.853 10.6954 17.0769 10.9192 17.353 10.9192H17.3648C17.641 10.9192 17.8648 10.6954 17.8648 10.4192C17.8648 10.1431 17.641 9.91921 17.3648 9.91921H17.353Z"
                          fill="#A5AEBC"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M27.4102 11.2432C28.2386 11.2432 28.9102 11.9147 28.9102 12.7432V19.4098C28.9102 20.2383 28.2386 20.9098 27.4102 20.9098H24.5213C24.2451 20.9098 24.0213 21.1337 24.0213 21.4098C24.0213 21.686 24.2451 21.9098 24.5213 21.9098H27.4102C28.7909 21.9098 29.9102 20.7905 29.9102 19.4098V12.7432C29.9102 11.3625 28.7909 10.2432 27.4102 10.2432H24.5213C24.2451 10.2432 24.0213 10.467 24.0213 10.7432C24.0213 11.0193 24.2451 11.2432 24.5213 11.2432H27.4102ZM20.5717 21.6421C20.1029 21.1732 19.467 20.9098 18.804 20.9098H15.334C15.0578 20.9098 14.834 21.1337 14.834 21.4098C14.834 21.686 15.0578 21.9098 15.334 21.9098H18.804C19.2018 21.9098 19.5833 22.0679 19.8646 22.3492L23.2788 25.7634C23.4741 25.9586 23.7907 25.9586 23.9859 25.7634C24.1812 25.5681 24.1812 25.2515 23.9859 25.0563L20.5717 21.6421Z"
                          fill="#A5AEBC"
                        />
                      </svg>
                    </div>
                    <span className="font-bold text-[14px]">Contact thryft</span>
                  </Tab> */}

                  <Tab
                    onClick={() => {
                      localStorage.clear();
                      window.location.pathname = "/";
                      setShow(true);
                    }}
                    active={false}
                  >
                    <div className="icon-wrapp">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.5 6C3.5 4.61929 4.61929 3.5 6 3.5H9C9.27614 3.5 9.5 3.72386 9.5 4C9.5 4.27614 9.27614 4.5 9 4.5H6C5.17157 4.5 4.5 5.17157 4.5 6V18C4.5 18.8284 5.17157 19.5 6 19.5H9C9.27614 19.5 9.5 19.7239 9.5 20C9.5 20.2761 9.27614 20.5 9 20.5H6C4.61929 20.5 3.5 19.3807 3.5 18V6ZM8.5 12C8.5 11.7239 8.72386 11.5 9 11.5H18.7929L15.6464 8.35355C15.4512 8.15829 15.4512 7.84171 15.6464 7.64645C15.8417 7.45118 16.1583 7.45118 16.3536 7.64645L20 11.2929C20.3905 11.6834 20.3905 12.3166 20 12.7071L16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536C15.4512 16.1583 15.4512 15.8417 15.6464 15.6464L18.7929 12.5H9C8.72386 12.5 8.5 12.2761 8.5 12Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <span className="font-bold text-[14px]">Logout</span>
                  </Tab>
                </div>
              </div>
            </div>
          </div>
        </div>
        {setPopup && (
          <BasicModal
            state={state}
            popup={popup}
            setPopup={setPopup}
            setState={setState}
            id={id}
          />
        )}
      </div>
    </SkeletonTheme>
  );
}

export default Sidebar;
